/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import PropTypes from 'prop-types';
import React from 'react';

import mcLib from '../../../api/mc-lib';

const logEvent = (title) => {
  mcLib.logEvent('Success Community Links', title);
};

function SuccessCommunityItem({ body, title, buttonLabel, url }) {
  return (
    <li className="slds-item">
      <h3 className="slds-section__title">{title}</h3>
      <div className="slds-text-color--weak slds-p-bottom--medium">{body}</div>
      <a
        className="slds-button slds-button--brand slds-size--1-of-1 slds-m-bottom--x-large"
        href={url}
        onClick={function () {
          logEvent(title);
        }}
        target="_blank"
        rel="noopener noreferrer"
      >
        {buttonLabel}
      </a>
    </li>
  );
}

SuccessCommunityItem.displayName = 'Success Community Item';

SuccessCommunityItem.propTypes = {
  body: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  url: PropTypes.string,
};

SuccessCommunityItem.defaultProps = {
  url: 'javascript:void(0);', // eslint-disable-line no-script-url
};

export default SuccessCommunityItem;
